import React from "react";
import { Link } from "react-router-dom";
import { Card, Typography, Col } from "antd";

import "./Posts.less";

const { Title, Paragraph, Text } = Typography;

export default function PostCard({ post }) {
  if (!post) return null;

  const { slug, title, description, date, featuredImage } = post.fields;

  return (
    <Col
      key={slug}
      xs={{ flex: "50%" }}
      md={{ flex: "33%" }}
      lg={{ flex: "25%" }}
    >
      <Card
        cover={
          featuredImage ? (
            <img
              className="post-card-cover"
              alt={title}
              src={featuredImage.fields.file.url ?? ""}
              style={{
                objectFit: "cover",
                width: "100%",
                height: "auto",
                aspectRatio: "1/1",
              }}
            />
          ) : null
        }
      >
        <Link to={`/post/${slug}`} style={{ color: "inherit" }}>
          <Text type="secondary" style={{ display: "block", marginBottom: 8 }}>
            {date}
          </Text>
          <Title level={3} style={{ marginBottom: 8 }}>
            {title}
          </Title>
          <Paragraph>{description}</Paragraph>
        </Link>
      </Card>
    </Col>
  );
}
